import React from 'react';
import { useInView } from '@/hooks/useInView';

export const HeroSection = ({ t, scrollToSection }) => {
  const [ref, isInView] = useInView();

  return (
    <section id="home" className="pt-20 min-h-screen flex items-center bg-gradient-to-br from-blue-900 via-purple-900 to-indigo-900 text-white relative overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0 bg-black/30"></div>
      <div className="absolute inset-0" style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1647427060118-4911c9821b82?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwZXF1aXBtZW50fGVufDB8fHx8MTc3MDg2MzgxMXww&ixlib=rb-4.1.0&q=85)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        opacity: 0.15
      }}></div>

      <div ref={ref} className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative z-10 transition-all duration-700 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        <div className="max-w-3xl">
          <h1 className="text-5xl md:text-7xl font-bold mb-6" data-testid="hero-title">{t.hero.title}</h1>
          <p className="text-3xl md:text-4xl mb-8 text-blue-300 font-semibold" data-testid="hero-tagline">{t.hero.tagline}</p>
          <p className="text-xl md:text-2xl mb-12 text-gray-200 leading-relaxed" data-testid="hero-description">
            {t.hero.description}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => scrollToSection('industries')}
              className="bg-blue-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-700 transition-all transform hover:scale-105"
              data-testid="hero-cta-industries"
            >
              {t.hero.exploreBtn}
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white/20 transition-all border border-white/30"
              data-testid="hero-cta-contact"
            >
              {t.hero.contactBtn}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
